import React from 'react';
import { useError } from '../contexts/ErrorContext';
import './ErrorNotification.css';

const ErrorNotification: React.FC = () => {
  const { errors, removeError } = useError();

  if (errors.length === 0) {
    return null;
  }

  const getIcon = (type: string) => {
    switch (type) {
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '❌';
    }
  };

  const getClassName = (type: string) => {
    switch (type) {
      case 'error':
        return 'error-notification error';
      case 'warning':
        return 'error-notification warning';
      case 'info':
        return 'error-notification info';
      default:
        return 'error-notification error';
    }
  };

  return (
    <div className="error-notifications-container">
      {errors.map((error) => (
        <div key={error.id} className={getClassName(error.type)}>
          <div className="error-content">
            <div className="error-header">
              <span className="error-icon">{getIcon(error.type)}</span>
              <span className="error-message">{error.message}</span>
              <button 
                className="error-close" 
                onClick={() => removeError(error.id)}
                aria-label="Закрыть"
              >
                ×
              </button>
            </div>
            {error.details && (
              <div className="error-details">{error.details}</div>
            )}
            {error.retryAction && (
              <div className="error-actions">
                <button 
                  className="retry-button"
                  onClick={() => {
                    error.retryAction?.();
                    removeError(error.id);
                  }}
                >
                  Попробовать снова
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ErrorNotification;
